import { Navigate, Outlet } from 'react-router-dom';
import Bootstrapper from '../components/Bootstrapper';
import { NotificationContainer } from '@alexpireddu/map-ui';
import {
  AccessDeniedPage,
  CheckAuthorization,
  DefaultErrorPage,
  ErrorBoundary,
  NotFoundErrorPage,
} from '../components';
import CitiesBootstrapper from '../components/CitiesBootstrapper';
import CityConfiguration from '../areas/CityConfiguration';
import Campaigns from '../areas/Campaigns';
import Booking from '../areas/Booking';
import Support from '../areas/Support';
import News from '../areas/News';
import { sentryCreateBrowserRouter } from '../infrastructure/sentryConfiguration';
import Overview from '../areas/CityConfiguration/Overview';
import Employees from '../areas/CityConfiguration/Employees';
import Sites from '../areas/CityConfiguration/Sites';
import PlanCommunication from '../areas/Booking/PlanCommunication';
import Recap from '../areas/Booking/Recap';
import Emergencies from '../areas/Emergencies';

export const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: (
      <ErrorBoundary>
        <Bootstrapper>
          <NotificationContainer />
          <Outlet />
        </Bootstrapper>
      </ErrorBoundary>
    ),
    errorElement: <DefaultErrorPage />,
    children: [
      {
        path: 'unauthorized',
        element: <AccessDeniedPage />,
      },
      {
        path: '/',
        element: <CheckAuthorization />,
        children: [
          {
            path: '*',
            element: <CitiesBootstrapper />,
            children: [
              {
                index: true,
                element: <Navigate to="campagne" />,
              },
              {
                path: 'configura',
                element: <CityConfiguration />,
              },
              {
                path: 'configura/:currentCityId/*',
                element: <CityConfiguration />,
                children: [
                  {
                    index: true,
                    element: <Navigate to="generale" />,
                  },
                  {
                    path: 'generale',
                    element: <Overview />,
                  },
                  {
                    path: 'collaboratori',
                    element: <Employees />,
                  },
                  {
                    path: 'impianti',
                    element: <Sites />,
                  },
                ],
              },
              {
                path: 'campagne/',
                element: <Campaigns />,
              },
              {
                path: 'campagne/:currentCityId',
                element: <Campaigns />,
              },
              {
                path: 'news/',
                element: <News />,
              },
              {
                path: 'news/:currentCityId',
                element: <News />,
              },
              {
                path: 'news/:currentCityId/edit',
                element: <News editMode />,
              },
              {
                path: 'emergenze/',
                element: <Emergencies />,
              },
              {
                path: 'emergenze/:currentCityId',
                element: <Emergencies />,
              },
              {
                path: 'emergenze/:currentCityId/edit',
                element: <Emergencies editMode />,
              },
              {
                path: 'prenota/:currentCityId/*',
                element: <Booking />,
                children: [
                  {
                    index: true,
                    element: <Navigate to="plan" />,
                  },
                  {
                    path: 'plan',
                    element: <PlanCommunication />,
                  },
                  {
                    path: 'recap',
                    element: <Recap />,
                  },
                ],
              },
              {
                path: 'support/',
                element: <Support />,
              },
              {
                path: 'support/:currentCityId',
                element: <Support />,
              },
              {
                path: '*',
                element: <NotFoundErrorPage />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
